<template v-if="href">
  <a-link-v2
    :url="href"
    :class="[name, `${name}__link`, { over: active }]"
    @mouseover.native="onCardHover(true)"
    @mouseleave.native="onCardHover(false)"
  >
    <grid
      :class="[`${name}__grid`]"
      :layout="[
        {
          size: 1,
          columns: 'repeat(12, 1fr)',
          gap: '6px',
        },
        {
          size: 2,
          columns: 'repeat(24, 1fr)',
          gap: '10px',
        },
      ]"
    >
      <grid-item
        :class="[`${name}__grid-item`, `${name}__thumbnail`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 1, width: 11 },
          { size: 3, x: 1, width: 10 },
          { size: 4, x: 1, width: 8 },
        ]"
      >
        <a-image-v2
          v-if="(cms.image || {}).filename"
          :src="(cms.image || {}).filename"
          :alt="(cms.image || {}).alt"
          :layout="layout"
          :class="[`${name}__image`, podcast ? `${name}__podcast` : '']"
        >
          <a-waveform v-if="podcast" />
        </a-image-v2>
      </grid-item>
      <grid-item
        :class="[`${name}__grid-item`, `${name}__content`]"
        :layout="[
          { size: 1, x: 1, width: 12 },
          { size: 2, x: 13, width: 12 },
          { size: 3, x: 12, width: 12 },
          { size: 4, x: 11, width: 12 },
        ]"
      >
        <a-eyebrow v-if="cms.eyebrow" :cms="cms" :class="`${name}__eyebrow`" />
        <a-heading v-if="cms.heading" :cms="cms" :class="`${name}__heading`" />
        <!-- eslint-disable vue/no-v-html -->
        <div
          v-if="cms.copy"
          :class="`${name}__text`"
          v-html="$options.filters.markdown(cms.copy)"
        />
        <!--eslint-enable-->
        <component
          :is="item.component"
          v-for="item in cms.cta"
          :key="item._uid"
          v-editable="item"
          html-tag="span"
          :cms="item"
          type="secondary"
          :class="`${name}__cta`"
        />
      </grid-item>
    </grid>
  </a-link-v2>
</template>

<script>
import Href from '@/mixins/href'
import data from '~/components/molecules/m-cards/m-card.data'
import AWaveform from '~/components/atoms/a-svgs/a-svg-waveform'

export default {
  components: { AWaveform },
  mixins: [Href],
  props: {
    cms: {
      type: Object,
      default() {
        const config = {}
        return process.env.NODE_ENV === 'development'
          ? { ...data, ...config }
          : config
      },
    },
    url: {
      type: String,
      default() {
        return null
      },
    },
    layout: {
      type: Array,
      default() {
        return [
          { size: 0, bound: 313, ratio: [313, 243] },
          { size: 1, bound: 425, ratio: [425, 290] },
          { size: 2, bound: 425, ratio: [425, 290] },
          { size: 3, bound: 425, ratio: [425, 290] },
        ]
      },
    },
  },
  data() {
    return {
      name: 'm-card',
      active: false,
    }
  },
  computed: {
    podcast() {
      return !!this.cms.podcast
    },
  },
  methods: {
    onCardHover(boolean) {
      this.active = boolean || false
    },
  },
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.m-card {
  display: inline-block;
  padding: 25px 0 50px;

  &__eyebrow {
    @include font-size(18, 25.2px);
  }

  &__heading {
    @include font-family($headings-font-family, 600);
    @include font-size(36, 40.8px);

    margin: 10px 0;
    letter-spacing: 1px;
  }

  &__thumbnail {
    position: relative;
    ::v-deep svg {
      position: absolute;
      transform: translate(-50%, -50%);
      top: 50%;
      left: 50%;
    }
  }

  &__cta {
    margin-top: 30px;
  }

  ::v-deep p,
  ::v-deep img,
  ::v-deep a,
  ::v-deep .a-cta {
    transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out,
      border 0.2s ease-in-out, 0.8s filter ease-in-out, opacity 0.2s ease-in-out;
  }

  &:hover {
    ::v-deep p {
      color: var(--text-color);
    }
    ::v-deep a {
      color: var(--hover-color);
    }
    ::v-deep .a-cta {
      color: var(--text-color);
    }
    ::v-deep .m-card__podcast img {
      filter: opacity(0.2);
    }
  }
}

@include media-breakpoint-up(md) {
  .m-card {
    &__heading {
      margin: 0 0 10px;
      @include font-family($headings-font-family, 600);
      @include font-size(26, 31.2px);
    }
  }
}

@include media-breakpoint-up(lg) {
  .m-card {
    &__heading {
      @include font-family($headings-font-family, 600);
      @include font-size(36, 40.8px);
    }
  }
}

@include media-breakpoint-up(xl) {
  .m-card {
    &__heading {
      max-width: 80%;
    }
  }
}
</style>
